export default "__VITE_ASSET__c1be0d97__"